/**
 * 用户角色枚举
 *
 * - SUPER_ADMIN: 超级管理员，系统最高权限，可管理所有活动和用户
 * - EVENT_ADMIN: 活动管理员，仅可管理被分配的活动/届次范围内的数据
 * - LEADER_READONLY: 领导只读，全局数据只读权限，用于领导查看大屏和报表
 */
export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  EVENT_ADMIN = 'EVENT_ADMIN',
  LEADER_READONLY = 'LEADER_READONLY',
}

/** 所有角色值的数组，用于校验 */
export const UserRoleValues: string[] = Object.values(UserRole);

/** 角色中文标签映射 */
export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: '超级管理员',
  [UserRole.EVENT_ADMIN]: '活动管理员',
  [UserRole.LEADER_READONLY]: '领导只读',
};

/** 角色描述映射 */
export const UserRoleDescriptions: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: '系统最高权限，可管理所有活动和用户',
  [UserRole.EVENT_ADMIN]: '仅可管理被分配的活动/届次范围内的数据',
  [UserRole.LEADER_READONLY]: '全局数据只读权限，用于查看大屏和报表',
};
